import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export const ChangeNote = ({ pct, dark = false, testid = "year-change-note" }) => {
  if (pct === null || pct === undefined) {
    return (
      <p className={`mt-1 text-xs ${dark ? "text-white/60" : "text-[#7A8A78]"}`} data-testid={testid}>
        No last-year data to compare
      </p>
    );
  }
  const up = pct > 0;
  const Icon = pct === 0 ? Minus : up ? ArrowUpRight : ArrowDownRight;
  const color = dark
    ? up ? "bg-white/15 text-[#BFE3B4]" : pct < 0 ? "bg-white/15 text-[#FCD9B6]" : "bg-white/15 text-white"
    : up ? "bg-[#EAF2E8] text-[#2D5A27]" : pct < 0 ? "bg-[#FDECEC] text-[#B42318]" : "bg-[#F1EFEA] text-[#526050]";
  return (
    <span className={`mt-2 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${color}`} data-testid={testid}>
      <Icon className="h-3.5 w-3.5" />
      {up ? "+" : ""}{pct}% vs last year
    </span>
  );
};
